export default function EditTrainingDocumentDirective() {
  return {
    template: require('./edit-document.directive.html'),
    scope: {
      newMediaInputs: '=',
      topic: '=',
      section: '=',
      media: '=',
    },
    controller: 'EditTrainingDocumentDirectiveController',
    controllerAs: 'editTrainingDocumentVM',
    bindToController: true,
    replace: true,
  };
}
